import React from "react";

export default function Renovasion() {
  return (
    <div className="container mt-20 flex justify-center items-center">
      <div className="w-3/4">
        <div className="grid grid-cols-1 md:grid-cols-3">
          <div className="col-span-2">
            <h5 className="font-bold text-xl text-green-700">
              Lorem, ipsum dolor.
            </h5>

            <p className="mt-1">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias
              quis modi vel numquam voluptatibus officia aut, consectetur
              dolorum voluptates sequi. Voluptatibus nesciunt laboriosam dolores
              modi?
            </p>
            
            <p className="mt-4">
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Veniam
              velit reiciendis delectus soluta, perspiciatis voluptatibus.
              Culpa, sequi dolorum totam illo voluptates maxime, a laboriosam
              quod itaque dolor, quos distinctio? Officiis ipsa quaerat
              praesentium harum autem temporibus rem quidem nesciunt
              consequuntur?
            </p>
          </div>
          <div className="col-span-1 mt-5 md:mt-0">
            <img
              src={require("../../images/renofasi.png")}
              alt="Gambar Renovasi"
              className="w-40 mx-auto"
            />
            <h5 className="text-lg text-green-700 text-center">
              Lorem ipsum dolor sit amet.
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}
